import { useEffect, useState, type ReactNode } from "react";
import { config } from "@/config";
import { authenticate } from "./oktaClient";
import { AuthContext, type AuthState } from "./useAuth";

/** Runs the Okta PKCE flow once on mount; children render only once resolved. */
export function AuthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AuthState>({
    authenticated: !config.enableOktaAuth,
    loading: config.enableOktaAuth,
  });

  useEffect(() => {
    if (!config.enableOktaAuth) {
      return;
    }
    let cancelled = false;
    authenticate()
      .then((result) => {
        if (!cancelled) {
          setState({ ...result, loading: false });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setState({ authenticated: false, loading: false });
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return <AuthContext.Provider value={state}>{children}</AuthContext.Provider>;
}
